<template>
  <div class="quote">
    <default-header :h2="$t('quote.title')" />
    <back-btn :shouldShowModal="true"></back-btn>

    <PhoneNumberModal v-if="showPhoneNumberModal" @send="resendSms" @close="closeModal" />

    <div class="innerContent noSpaceBetween mb-4">
      <div class="additionalPadding small">
        <h6 class="testResult__title mb-3">{{$t('quote.completeContact')}}</h6>
        <input-standard
          :valueFromParent="client.firstName"
          :disabled="true"
          :label="$t('general.name')"
        />
        <input-standard
          :valueFromParent="client.lastName"
          :disabled="true"
          :label="$t('general.lastName')"
        />

        <input-standard
          v-if="client.telephone && client.telephone.length > 3"
          :valueFromParent="client.telephone"
          :disabled="true"
          :label="$t('general.telephone')"
        />

        <input-standard
          v-if="client.email"
          :valueFromParent="client.email"
          :disabled="true"
          :label="$t('general.email')"
        />

        <div class="quote__battery" v-for="(battery, index) in quote" :key='index'>
          <div class="quote__battery__remove" @click="removeFromQuoteAndChosen(battery, index)">
            <font-awesome-icon :icon="['fa', 'times' ]" />
          </div>
          <div class="quote__battery__img">
            <img class="quote__battery__img-img" v-if="battery.image" :src="battery.image" />
            <img class="quote__battery__img-img" v-else src="../assets/battery_placeholder.png" />
            <div
              class="quote__battery__name"
            >{{ battery.manufacturer + " " + battery.model + " " + battery.capacity }}</div>
          </div>

          <div class="quote__battery__prices">
            <label class="switchCheckbox">
              <input
                @change="handlePriceCheckboxChange(index)"
                :checked="battery.cost_separately"
                type="checkbox"
              />
              <span class="sliderCheckbox round"></span>
            </label>
            <span class="quote__battery__prices-check">{{$t('quote.addService')}}</span>
          </div>

          <input-standard
            :ref="'input'+index"
            :type="'number'"
            :name="'battery_price'"
            :moneySign="user.currency.label"
            :label="battery.cost_separately ? $t('general.priceBattery') : $t('general.price')"
            :index="index"
            :error="battery.errorPriceBattery ? $t('quote.requiredPriceBattery') : ''"
            @changedValue="handleInputChangedValue"
          />
          <input-standard
            :ref="'input'+index"
            v-if="battery.cost_separately"
            :moneySign="user.currency.label"
            :type="'number'"
            :name="'service_price'"
            :label="$t('quote.PriceService')"
            :index="index"
            :error="battery.errorPriceService ? $t('quote.requiredServicePrice') : ''"
            @changedValue="handleInputChangedValue"
          />
          <input-standard
            @changedValue="handleInputChangedValue"
            :index="index"
            :name="'comment'"
            :label="$t('quote.commentOptional')"
          />
        </div>
        <button 
          class="btn btn-primary w-100 mt-3" 
          @click="validateQuote"
          :disabled="submitButtonIsDisabled"
        >{{$t('general.send')}}</button>
      </div>
    </div>
    <bottom-navigation />
  </div>
</template>

<script>
import DefaultHeader from '../partials/DefaultHeader';
import BottomNavigation from '../partials/BottomNavigation';
import InputStandard from '../components/InputStandard';
import { mapGetters } from 'vuex';
import { HTTP } from '../http';
import BackBtn from '../components/BackBtn';
import PhoneNumberModal from '../components/PhoneNumberModal';

export default {
  name: 'Quote',
  components: {
    DefaultHeader,
    BottomNavigation,
    InputStandard,
    BackBtn,
    PhoneNumberModal
  },
  data() {
    return {
      quote: [],
      showPhoneNumberModal: false,
      smsStatus: {},
      submitButtonIsDisabled: false,
    };
  },

  mounted() {
    this.quote = this.chosenBatteries;
  },
  computed: {
    ...mapGetters({
      client: 'getCurrentClient',
      chosenBatteries: 'getChosenBatterries',
      currentTestResult: 'getCurrentTestResult',
      user: 'getUser'
    })
  },
  methods: {
    removeFromQuoteAndChosen(battery, index) {
      this.$store.commit('removeFromChosenBatteries', battery);
      this.quote.splice(index, 1);
    },
    handlePriceCheckboxChange(index) {
      if (!this.quote[index].cost_separately) {
        this.quote[index].cost_separately = true;
      } else {
        this.quote[index].cost_separately = false;
      }
      this.clearErrors(index);
      this.quote[index].battery_price = '';
      this.quote[index].service_price = '';
      this.$refs['input' + index].forEach(input => {
        input.value = '';
      });
    },
    handleInputChangedValue(index, name, value) {
      this.quote[index][name] = value;
    },
    validateQuote() {
      let errors = 0;
      this.clearErrors(0);
      this.clearErrors(1);
      this.clearErrors(2);
      for (let i = 0; i < this.quote.length; i++) {
        if (!this.quote[i].cost_separately) {
          if (!this.quote[i].battery_price) {
            this.quote[i].errorPriceBattery = true;
            errors++;
          }
        } else {
          if (!this.quote[i].battery_price) {
            this.quote[i].errorPriceBattery = true;
            errors++;
          }
          if (!this.quote[i].service_price) {
            this.quote[i].errorPriceService = true;
            errors++;
          }
        }
      }
      this.$forceUpdate();
      errors === 0 ? this.sendQuote() : false;
    },
    clearErrors(index) {
      if (this.quote[index]) {
        this.quote[index].errorPriceBattery = false;
        this.quote[index].errorPrice = false;
        this.quote[index].errorPriceService = false;
      }
    },
    resendSms(phone) {
      this.showPhoneNumberModal = false;
      HTTP.patch(`/api/clients-phone-number/${this.client.id}`, {
        phone_number: phone
      })
        .then(() => {
          this.sendQuote()
        })
        .catch(() => {
          this.$toasted.show(this.$i18n.t('quote.somethingWrong'))
        });
    },
    closeModal() {
      this.showPhoneNumberModal = false
    },
    sendQuote() {
      if (this.submitButtonIsDisabled) {
        // Allow only one form subition at same time.
        return
      }
      this.submitButtonIsDisabled = true

      HTTP.post('/api/quote', {
        client_id: this.client.id,
        battery_tests_result_id: this.currentTestResult.id,
        batteries: this.quote,
      })
        .then(res => {
          if(res.data.hasOwnProperty('hash')) {
            const hash = res.data.hash

            this.$toasted.show('Sending SMS...', {
              duration: null,
              className: 'success',
              onComplete: () => {
                this.smsStatus[hash] = 'hidden'
              },
              action: [
                {
                  text : 'Hide',
                  onClick : (e, toastObject) => {
                    this.smsStatus[hash] = 'hidden'
                    toastObject.goAway(0)
                  }
                },
              ]
            });
            this.checkSmsStatus(hash, 1);
          } else {
            this.$store.state.user.user.isNew = 0;
            this.$router.push({ name: 'Dashboard' });
          }
        })
        .catch(err => {
          if (err && err.hasOwnProperty('response')) {
            if (err.response.data.smsError) {
              if (err.response.data.smsError && err.response.data.smsErrorType == 'invalid_number') {
                this.$toasted.clear();
                this.showPhoneNumberModal = true;
              } else {
                this.$toasted.show(this.$i18n.t('testResult.somethingWrong'));
              }
            }
          } else {
            this.$toasted.show(this.$i18n.t('quote.somethingWrong'));
          }

          this.submitButtonIsDisabled = false
        });
    },
    checkSmsStatus(hash, counter) {

      if(this.smsStatus[hash] === 'hidden') {
        return
      }

      if (counter > 20) {
        // Maximum retry count exceed. 
        this.submitButtonIsDisabled = false

        this.smsStatus[hash] = 'failed';
        this.$toasted.clear()
        this.$toasted.show('Unable to confirm the message was send correctly.')

        return
      }

      // TODO: This should be GET request.
      HTTP.post('/api/check-sms-status', {
        'hash': hash
      }).then(response => {
        if(!response.data.hasOwnProperty('status') || ['failed','undelivered','pre_failed'].includes(response.data.status)) {
          this.smsStatus[hash] = 'failed';
          this.$toasted.clear();
          this.$toasted.show('Sending SMS failed.');
        }

        if(['delivered','received'].includes(response.data.status)) {
          let store = this.$store;
          let router = this.$router;

          this.smsStatus[hash] = 'delivered';
          this.$toasted.clear();
          this.$toasted.show(this.$i18n.t('quote.quoteSend'), {
            className: 'success',
            onComplete() {
              store.state.user.user.isNew = 0;
              router.push({ name: 'Dashboard' });
            }
          });
        }

        if(['sent','accepted','queued','sending','receiving','received',null].includes(response.data.status)) {
          counter++;
          setTimeout(() => {
            this.smsStatus[hash] = 'sending';
            this.checkSmsStatus(hash, counter)
          }, 3000);
        }

      }).catch(err => {
        this.smsStatus[hash] = 'failed';
      });
    },
  }
};
</script>
